export default "__VITE_ASSET__1d$YAZJZ__";